import GlitchH1 from "./GlitchH1.vue";

export default GlitchH1;
